import styled from 'styled-components';

import { spacing } from 'ui/theme/utils';

export const Badge = styled.span`
  display: flex;
  padding: 2px 8px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.04em;
  text-align: center;
  line-height: initial;
  background-color: ${({ bg = '#ffecd2' }) => bg};
  color: ${({ theme, color = '#ac7206' }) => theme.colors[color] || color};
  ${(props) => spacing(props)}
`;
